import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=5964f9cb&"
import script from "./Platforms.vue?vue&type=script&lang=js&"
export * from "./Platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports